export default "__VITE_ASSET__BAOaPJ_X__"